import MTB from './imgs/ntsbricks.png';
const BricksData = [
    {
        id:"1",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"2",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"3",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"4",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"5",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"6",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"7",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"8",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"9",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
    {
        id:"10",
        imgsrc: MTB,
        title: "MTB Bricks",
        qty: "1",
        cost: "₹10.00"
    },
];
export default BricksData;